export enum SignatureAlgorithm {
    sha1 = 'sha1',
    sha256 = 'sha256',
    sha384 = 'sha384',
    sha512 = 'sha512'
}